import { type FC, Fragment, type ReactNode } from 'react';
import { type PopupPlacement } from '@direct-frontend/components';
import { type DashboardTodoListFeatureHintId } from '../../../../lib/featureHints';
import { FeatureHintTooltip } from '../../../FeatureHintTooltip';
import { type DashboardTodoListItemFeatureHintsConfig } from '../../DashboardTodoListItem.types';

export type DashboardTodoListItemFeatureHintSlotProps = {
    hintId: DashboardTodoListFeatureHintId;
    featureHints: DashboardTodoListItemFeatureHintsConfig | undefined;
    placement: PopupPlacement;
    /** Суффикс для `data-testid`: `Title` → `….FeatureHint.Title` */
    testIdSuffix: string;
    'data-testid'?: string;
    children: ReactNode;
};

export const DashboardTodoListItemFeatureHintSlot: FC<DashboardTodoListItemFeatureHintSlotProps> = ({
    hintId,
    featureHints,
    placement,
    testIdSuffix,
    'data-testid': dataTestId,
    children,
}) => {
    if (!featureHints) {
        return <Fragment>{children}</Fragment>;
    }

    const copy = featureHints.copy[hintId];

    return (
        <FeatureHintTooltip
            caption={copy.caption}
            data-testid={dataTestId ? `${dataTestId}.FeatureHint.${testIdSuffix}` : undefined}
            isClosing={featureHints.closingHintId === hintId}
            isOpen={featureHints.activeHintId === hintId}
            placement={placement}
            title={copy.title}
            onCloseComplete={() => featureHints.onCloseComplete(hintId)}
            onDismiss={() => featureHints.onDismiss(hintId)}
        >
            {children}
        </FeatureHintTooltip>
    );
};
